export default {
  previousPage: 'Page précédente',
  nextPage: 'Page suivante',
  of: 'sur',
};
